<template>
  <div v-if="types.length > 0" class="modal-bg">
    <div class="modal reorder-blocks">
      <h1>Ordenar blocos</h1>
      <draggable v-model="types" :class="'block-order'">
        <template v-slot:item="{ item }">
          <label>{{ item.name }}</label>
        </template>
      </draggable>
      <fyi-button :label="'Guardar'" :className="'default'" :onclick="submit" />
      <i class="i-close" :onclick="close" />
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import Draggable from "vue3-draggable";
import { onBeforeMount, ref } from "vue";

export default {
  name: "ReorderBlocksModal",
  components: {
    Draggable,
  },
  props: {
    type: {
      type: [Number, String],
      default: null,
    },
  },
  emits: ["close"],
  setup(props, { emit }) {
    const store = useStore();
    const types = ref([]);
    const submit = async () => {
      types.value.forEach((type, index) => {
        type.orderposition = index + 1;
      });
      await store.dispatch("postTypesBlockOrder", {
        id: props.type,
        data: { blocks: types.value },
      });
      close();
    };

    const close = () => {
      emit("close");
    };

    onBeforeMount(async () => {
      types.value = await store.dispatch("getTypesBlockOrder", props.type);
      if (types.value.length === 0) {
        close();
      }
    });

    return { types, submit, close };
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/components/layout/modals";
</style>
